import {InfoWindow, Marker as GMarker} from '@react-google-maps/api';
import {IMAGE_URLS} from "../../utils/imageUtils";
import {MarkerNodeProps} from "./mapTypes";
import * as React from "react";

const { MARKER_ICON } = IMAGE_URLS;

const Marker = (props: MarkerNodeProps) => {

    const {marker, onCloseClick, onClick, isSelected} = props;

    return !!marker.id ? (
        <GMarker
            title={marker.title}
            position={{ lat: marker.lat, lng: marker.lng }}
            icon={MARKER_ICON}
            onClick={onClick}>
            {isSelected && marker.popupContent ? (
                <InfoWindow onCloseClick={onCloseClick}>{marker.popupContent}</InfoWindow>
            ) : null}
        </GMarker>
    ) : null;
};

export default React.memo(Marker, (prev, next) => {
    return !!prev.isSelected === !!next.isSelected;
});
